import { render, staticRenderFns } from "./studioDashboardDaycareStatistic.vue?vue&type=template&id=ac1416e8&scoped=true"
import script from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycareStatistic.vue?vue&type=style&index=0&id=ac1416e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1416e8",
  null
  
)

export default component.exports